import * as React from 'react';
import { useActions } from 'utils/connect';
import { useHistory } from 'react-router-dom';
import { useMountEffect } from '@tock/hooks';

interface Props {
  to: string;
}

/**
 * Drop-in replacement for a bare <Redirect> at the end of a v5 Switch.
 * Shows an informational toast before redirecting so users with stale
 * bookmarks understand why they've been moved.
 */
const NotFoundRedirect: React.FC<Props> = ({ to }) => {
  const { actions } = useActions();
  const history = useHistory();

  useMountEffect(() => {
    actions.toast.showInfo(
      'You have been redirected. You either have a stale bookmark or tried navigating to a page that does not exist. Please verify your bookmark.'
    );
    history.replace(to);
  });

  return null;
};

export default NotFoundRedirect;
